import React from "react";
import PropTypes from 'prop-types';
import { 
  Dialog, DialogContent, DialogTitle, Box, useTheme, 
  IconButton, Typography, Fade, Paper
} from "@mui/material";
import ChooseArgsForm from "../Forms/ChooseArgsForm";
import CloseIcon from '@mui/icons-material/Close';

export default function ChooseArgsDialog({ open, onClose, task, onUpdate }) {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 400 }}
      PaperProps={{
        elevation: 10,
        sx: {
          bgcolor: theme.palette.mode === 'dark' 
            ? 'rgba(30, 30, 30, 0.85)' 
            : 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(12px)',
          borderRadius: 3,
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden',
        },
      }}
    >
      <Paper elevation={0} sx={{ 
        bgcolor: 'transparent', 
        background: theme.palette.mode === 'dark'
          ? 'linear-gradient(to right, rgba(50, 50, 50, 0.4), rgba(30, 30, 30, 0.2))'
          : 'linear-gradient(to right, rgba(240, 240, 240, 0.4), rgba(255, 255, 255, 0.2))'
      }}>
        <Box 
          display="flex" 
          justifyContent="space-between" 
          alignItems="center" 
          p={2.5}
          sx={{ 
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          <DialogTitle sx={{ 
            p: 0, 
            fontWeight: 600,
            color: theme.palette.text.primary
          }}>
            <Typography variant="h5">Edit Task</Typography>
          </DialogTitle>
          <IconButton
            color="error"
            onClick={onClose}
            sx={{ 
              transition: 'all 0.2s',
              '&:hover': { 
                transform: 'rotate(90deg)',
                bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 50, 50, 0.1)' : 'rgba(255, 0, 0, 0.08)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Paper>
      
      <DialogContent >
       
          <ChooseArgsForm
            task={task}
            onSubmit={(updatedTask) => {
              onUpdate(updatedTask);
              onClose();
            }}
          />
      </DialogContent>
    </Dialog>
  );
}

ChooseArgsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
